import { useAppStore } from '@/store/useAppStore.ts'
import { CapacityUnit, type CapacityUnit as CapacityUnitType } from '@brt/shared-types'
import { ScrubInput, Select } from 'calc-controls'

const CAPACITY_OPTIONS = [
  { value: CapacityUnit.MAH, shortLabel: 'mAh', fullLabel: 'Milliamp-hours (mAh)' },
  { value: CapacityUnit.AH, shortLabel: 'Ah', fullLabel: 'Amp-hours (Ah)' },
  { value: CapacityUnit.WH, shortLabel: 'Wh', fullLabel: 'Watt-hours (Wh)' },
  { value: CapacityUnit.KWH, shortLabel: 'kWh', fullLabel: 'Kilowatt-hours (kWh)' },
]

const UNIT_SELECT_OPTIONS = CAPACITY_OPTIONS.map((opt) => ({
  value: opt.value,
  label: opt.fullLabel,
}))

export function CapacityInput() {
  const capacityValue = useAppStore((s) => s.battery.capacityValue)
  const capacityUnit = useAppStore((s) => s.battery.capacityUnit)
  const voltage = useAppStore((s) => s.battery.voltage)
  const updateBattery = useAppStore((s) => s.updateBattery)

  const showVoltage = capacityUnit === CapacityUnit.WH || capacityUnit === CapacityUnit.KWH

  return (
    <div className="capacity-input">
      <ScrubInput
        label="Capacity"
        value={capacityValue || 0}
        onChange={(v) => updateBattery('capacityValue', v)}
        unit={CAPACITY_OPTIONS.find((o) => o.value === capacityUnit)?.shortLabel ?? ''}
        min={0}
        step={1}
        decimals={2}
      />
      <Select
        label="Unit"
        options={UNIT_SELECT_OPTIONS}
        value={capacityUnit}
        onChange={(v) => updateBattery('capacityUnit', v as CapacityUnitType)}
      />
      {showVoltage && (
        <p className="capacity-input__voltage-note">
          At {voltage}V reference voltage
        </p>
      )}
    </div>
  )
}
